jQuery(function($){
   $('.my_gallery_group_main_inner .my_gallery_item').magnificPopup({
        type: 'inline',
        preloader: false,
     mainClass: 'mfp-fade'
    });
  
  $(document).on('click', '.popup-modal-dismiss', function (e) {
		e.preventDefault();
		$.magnificPopup.close();
	});
  
  /*
  //This js for jw-product-rule-with-list-out-function.liquid
  if($('.my_jw_prdocut_rule').length){
    $('#my_jw_prdocut_rule_add_to_cart_btn').click(function(){
    	$('.my_jw_prdocut_rule').removeClass('jw_hide_cls');
    });
    
    function checkAndShowRelatedProduct(){
    	var my_select_index = $('#data-product-option-0 option:selected').index();
      var flashing_yes_or_no = $("input[name='flashing_yes_or_no']:checked").val();
 	 
      if(flashing_yes_or_no == 'yes'){
        var real_show_index = $('#jw_my_index ul li').eq(my_select_index).data('jw-index');
         //console.log('My real index ====='+real_show_index);
      $('.my_jw_product_grid_layout .productgrid--items .productgrid--item').hide();
      $('.my_jw_product_grid_layout ul li').eq(real_show_index).show();
        $('#my_jw_prdocut_rule_tips_text').removeClass('jw_hide_cls');
         //$('#jw-product-rule-payment-button').hide();
      }else{
         $('.my_jw_product_grid_layout .productgrid--items .productgrid--item').hide();
        $('#my_jw_prdocut_rule_tips_text').addClass('jw_hide_cls');
        //$('#jw-product-rule-payment-button').show();
      }
       //console.log(my_select_index+'====='+flashing_yes_or_no);
    }
    
    $('#data-product-option-0').change(function() {
 		checkAndShowRelatedProduct();
	});
    
    $('input[type=radio][name=flashing_yes_or_no]').change(function() {
   		checkAndShowRelatedProduct();
	});
    checkAndShowRelatedProduct();
  }*/

   // Function to add items to the cart using a custom structure
    function jwAddDSHToCart() {
       if ($('#jw_match_dsh_prd_list_main option').length > 0) {
           // Get the selected index of Dropdown A (using its class)
            var selectedIndexA = $('.options-selection__input-select').prop('selectedIndex');
            
            // Get the corresponding product ID from Dropdown B based on the selected index
            var selectedProductIdB = $('#jw_match_dsh_prd_list_main option').eq(selectedIndexA).val();
          //console.log( selectedProductIdB);
            var my_items = [];
            
            // Define the item object with the selected product ID (without width and height properties)
            var item = { 
                'id': selectedProductIdB,
                'quantity': 1  // Quantity is set to 1
            };
            
            my_items.push(item);
        
            // If there are items to add, proceed with the AJAX request
            if (my_items.length > 0) {
                // Create the data object for the AJAX request
                const data = {
                    items: my_items
                };
        
                // Use XMLHttpRequest to send the data to the cart
                const xhr = new XMLHttpRequest();
                xhr.open('POST', '/cart/add.js', true);
                xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                xhr.send(JSON.stringify(data));
                
                // Handle the response when the request is complete
                xhr.onload = function () {
                    if (xhr.status == 200) {
                        // Redirect to the cart page after 2 seconds
                        setTimeout(function() {
                           $('.jw-dsh-overlay').css({
                            'visibility': 'hidden',
                            'opacity': '0'
                          });
                          $('#jw-product-rule-trigger').trigger('click');
                        }, 2000);
                        //console.log('ok');
                    }else{
                     // console.log('fail');
                        // Redirect to the cart page after 2 seconds
                        setTimeout(function() {
                       $('.jw-dsh-overlay').css({
                            'visibility': 'hidden',
                            'opacity': '0'
                          });
                          $('#jw-product-rule-trigger').trigger('click');
                        }, 2000);
                    }
                };
            } else {
                // Optionally, show an alert or message if no options are selected
                // alert('Please choose some options first');
            }
        }
    }
  
   if($('#jw-product-rule-with-popup').length){//if has popup rule function
      $('#jw-product-rule-trigger').magnificPopup({
        type: 'inline',
        preloader: false,
    	 mainClass: 'mfp-fade'
        
    });
     
    $('#my_jw_prdocut_rule_add_to_cart_btn').click(function(){
          if ($('#jw_match_dsh_prd_list_main option').length > 0) { 
            $('.jw-dsh-overlay').css({
              'visibility': 'visible',
              'opacity': '1'
            });
             // Delay the Add to Cart action by 2 seconds
            setTimeout(function() {
              jwAddDSHToCart();
             }, 1000); // 2000 milliseconds (2 seconds delay)
          }else{
             $('#jw-product-rule-trigger').trigger('click');
          }
    
    });
     
    $('#jw-product-rule-with-popup .my_jw_prdocut_rule_with_popup_body #flashing_yes').click(function(e){
      e.preventDefault();
      //var my_select_index = $('#data-product-option-0 option:selected').index();
      var my_select_index = $('.options-selection__select-wrapper select[data-variant-option-index="0"] option:selected').index();
     // var real_show_index = $('#jw_my_index ul li').eq(my_select_index).data('jw-index');
      var jw_link = $('#jw_my_product_with_link ul li').eq(my_select_index).data('jw-link');
        
      if(jw_link){
        window.location.href = jw_link;
      }else{
        $('#jw-product-rule-with-popup .mfp-close').trigger('click');
      }
      
    }); 
   }
  
  if($('#jw-single-flashing-select-color').length){//if has color option
    function checkJWColorShowOrHide(){
      //var roof_type = $('#data-product-option-0 option:selected').val();
      var roof_type = $('.options-selection__select-wrapper select[data-variant-option-index="0"] option:selected').val();
     // console.log('My roof type==='+roof_type);
      if(roof_type.includes('Metaldeck') || roof_type.includes('Metal') || roof_type.includes('Corrugated') || roof_type.includes('Trimdek') || roof_type.includes('Kliplock')){
          $('#jw-single-flashing-select-color').show();
          $('#jw-single-flashing-select-color #jw-select-color ').prop('disabled', false);
      }else{
        $('#jw-single-flashing-select-color').hide();
          $('#jw-single-flashing-select-color #jw-select-color ').prop('disabled',true)
      }
    }
    checkJWColorShowOrHide();
     $('.options-selection__select-wrapper select[data-variant-option-index="0"]').change(function() {
 		checkJWColorShowOrHide();
	});
    
  }
  
  
   if($('#you_are_in_cart_page').length){//if has cart popup rule function
     function cartPopupRule(){
       var final_cart_total = 0;
      $('.jw-cartitem-list .jw-cart-item .form-field-number').each(function(){
        var my_val = this.value;
        my_val = parseInt(my_val);
        final_cart_total = final_cart_total + my_val;
      });
      //console.log('===='+final_cart_total+'====');
       return final_cart_total;
       
     }
     
     
     /* $('#jw-cart-rule-trigger').magnificPopup({
        type: 'inline',
        preloader: false,
    	 mainClass: 'mfp-fade',
        closeOnBgClick:false
        
    });
     var my_final_cart_total = cartPopupRule();
     if(my_final_cart_total >9){
  
    	 $('#jw-cart-rule-trigger').trigger('click');
     }
     
     
     $('.jw-cart-form').submit(function(e){
        var my_final_cart_total = cartPopupRule();
       if(my_final_cart_total >9){
          e.preventDefault();
         $('#jw-cart-rule-trigger').trigger('click');
       }
	});  */
   }
  
  
   if($('#jw_msg_popup_flag').length){//if has msg popup
       $('#jw_msg_popup-trigger').magnificPopup({
         type: 'inline',
         preloader: false,
    	 mainClass: 'mfp-fade'
      });
     
     var my_template = $('#jw_msg_popup_current_template').val();
     var my_flag=Cookies.get(my_template);
     if(my_flag != 'no'){//only show once
       Cookies.set(my_template,'no');
       //console.log('dddd');
       $('#jw_msg_popup-trigger').trigger('click');
     }
   }
  
  
  $('.site-navigation a[href="#"]').click(function(e){
    e.preventDefault();
  });
  
  
  if($('#my_product-price-selector').length){
    function jw_update_discount_on_product_page(){
    var my_rate = $('#my_rate').val();
    	//console.log('tttttt');
      	//$('#my_product-price-selector').hide();
      	var my_price = $('#my_discount_original_price').text().replace("$", "").replace(",", "");
     
      if(my_price){
         my_price = parseFloat(my_price);	
        var my_price_no_dollar = my_price;
      	var my_final_price = my_price_no_dollar*my_rate;
         //console.log(my_final_price+'========'+my_rate);
        //my_final_price = parseInt(my_final_price);
        my_final_price = my_final_price.toFixed(2);
       // var final_price_string = '$'+ my_final_price+'.00';
        var final_price_string = '$'+ my_final_price;
        
      	//console.log( my_price );
        //console.log(final_price_string);
        
        var my_afterpay_val = (my_final_price / 4).toFixed(2);
        var my_afterpay_val_string = '$'+my_afterpay_val+' '+'AUD';
        //console.log(my_afterpay_val_string);
        //jw_my_dsicount_flag
       var my_discount_flag =  (my_price_no_dollar - my_final_price).toFixed(2);
        var my_discount_flag_string = '$'+my_discount_flag;
        setTimeout(
        function() 
        {
           $('#my_product-price-selector').text(final_price_string);
          //do something special
           $('.afterpay-instalments').text(my_afterpay_val_string);
          $('#jw_my_dsicount_flag').text(my_discount_flag_string);
          	//$('#my_product-price-selector').fadeIn();
        }, 800);

            }
       
    }
    
    $('#shopify-section-static-product .form-field-select-wrapper > select').change(function(){
      	jw_update_discount_on_product_page();
  	});
                                                                                    
    jw_update_discount_on_product_page();
  }
  
  if($('#jw-newsletter-popup-trigger').length > 0){
  
   $('#jw-newsletter-popup-trigger').magnificPopup({
         type: 'inline',
         preloader: false,
    	removalDelay: 300,
		mainClass: 'my-mfp-zoom-in'
      });
  
    var my_home_popup_once = Cookies.get('home-popup-once');
    if(my_home_popup_once){
      
    }else{
      Cookies.set('home-popup-once', 'yes');
      $('#jw-newsletter-popup-trigger').trigger('click');
    }
    
  	
  }

   if($('.jw_video_review_wrapper_inner').length > 0){
     $('.jw_video_review_wrapper_inner').slick({
        //infinite: true,
       autoplay: true,
       autoplaySpeed: 5000,
        arrows: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
           {
            breakpoint: 1500,
            settings: {
              slidesToShow: 4
            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2
            }
          },   
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });

     $('.jw_video_review_arrow_left').click(function(){
        $('.jw_video_review_wrapper_inner').slick('slickPrev');
      });
     
  	$('.jw_video_review_arrow_right').click(function(){
          $('.jw_video_review_wrapper_inner').slick('slickNext');
      });


     $('.jw-popup-video').magnificPopup({
		type: 'iframe',
		mainClass: 'mfp-fade',
		removalDelay: 160,
		preloader: false,

		fixedContentPos: false
	});
   }

  if($('.jw_logo_list_wrapper_inner').length > 0){
     $('.jw_logo_list_wrapper_inner').slick({
        //infinite: true,
       autoplay: true,
       autoplaySpeed: 5000,
        arrows: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
           {
            breakpoint: 1500,
            settings: {
              slidesToShow:5
            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 4
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3
            }
          },   
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2
            }
          }
        ]
      });
  }

  if($('.jw_read_more').length >0){
    $('.jw_read_more_btn').click(function(e){
      e.preventDefault();
      if($('.jw_read_more').hasClass('jw_read_more_open')){
        $('.jw_read_more').removeClass('jw_read_more_open');
        $('.jw_read_more_btn').html('More »');
      }else{
        $('.jw_read_more').addClass('jw_read_more_open');
        $('.jw_read_more_btn').html('Less «');
      }
    });
  }

     if($('.jw_frequently_bought_wrapper_inner').length > 0){
     $('.jw_frequently_bought_wrapper_inner').slick({
        //infinite: true,
      // autoplay: true,
       //autoplaySpeed: 5000,
        arrows: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
           {
            breakpoint: 1500,
            settings: {
              slidesToShow: 4
            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2
            }
          },   
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });

     $('.jw_frequently_bought_arrow_left').click(function(){
        $('.jw_frequently_bought_wrapper_inner').slick('slickPrev');
      });
     
  	$('.jw_frequently_bought_arrow_right').click(function(){
          $('.jw_frequently_bought_wrapper_inner').slick('slickNext');
      });

   }

  $('.jw_livechat_toggle,a[href="#jw-live-chat"]').click(function(e){
   e.preventDefault();
    var iframe = $("#dummy-chat-button-iframe");
    if(iframe){
     var elmnt = iframe.contents().find(".chat-toggle").eq(0);
     elmnt.click();
    }
  });

  if($('.jw_get_the_look_inner_group_box_inner').length > 0){
    $('.jw_get_the_look_inner_group_box_inner').each(function(){
       $(this).magnificPopup({
		delegate: 'a',
		type: 'image',
		closeOnContentClick: false,
		closeBtnInside: false,
		mainClass: 'mfp-with-zoom mfp-img-mobile jw-my-get-in-look-gallery',
		image: {
			verticalFit: true,
			titleSrc: function(item) {
                var my_title = item.el.attr('title');
                if(my_title){
				return my_title;
                }
			}
		},
		gallery: {
			enabled: true
		},
		zoom: {
			enabled: true,
			duration: 300, // don't foget to change the duration also in CSS
			opener: function(element) {
				return element.find('img');
			}
		}
		
	});
    });
 
  }

  //Cart insurance rules
  if($('#transitInsurance').length > 0){

    function cartInsuranceDeleteAll(){
      $('.cartitems .cart-item[data-cartitem-id="40561759289425"] .cart-item__remove-link').trigger('click');
      $('.cartitems .cart-item[data-cartitem-id="40561759322193"] .cart-item__remove-link').trigger('click');
      $('.cartitems .cart-item[data-cartitem-id="40561759354961"] .cart-item__remove-link').trigger('click');
      $('.cartitems .cart-item[data-cartitem-id="40561759387729"] .cart-item__remove-link').trigger('click');
    }

     function cartInsuranceTickStatus(){
     if ($('.cartitems .cart-item[data-cartitem-id="40561759289425"]').length >0 || $('.cartitems .cart-item[data-cartitem-id="40561759322193"]').length >0 || $('.cartitems .cart-item[data-cartitem-id="40561759354961"]').length >0 || $('.cartitems .cart-item[data-cartitem-id="40561759387729"]').length >0) {
            $('#transitInsurance').prop('checked', true);
            //console.log("ttt");
      }else{
         $('#transitInsurance').prop('checked', false);
      }
    }
    
    $('#transitInsurance').change(function(){
       var my_value = $('#my-cart-total').html();
       if(my_value){
         my_value = Number(my_value.replace(/[^0-9.-]+/g,""));
       }  
       var isChecked = $(this).prop('checked');
       if (isChecked) {
           cartInsuranceDeleteAll()
            var variantId = 40561759289425; // Transit Insurance variant ID - default $25
            if(my_value <= 1000){
              variantId = 40561759289425;
            }else if(my_value > 1000 && my_value <= 3000){
              variantId = 40561759322193;
            }else if(my_value > 3000 && my_value <= 5000){
              variantId = 40561759354961;
            }else if(my_value > 5000){
              variantId = 40561759387729;
            }else{
              variantId = 40561759289425;
            }
         
            //Shopify.addItem(40460796756049, 1);
             //alert("ttt");
              $.ajax({
                type: 'POST', 
                url: '/cart/add.js',
                dataType: 'json', 
                data: {id:variantId,quantity:1},
                success: function(){
                    location.href="/cart";
                }
             });
        } else {
            cartInsuranceDeleteAll();
        }
    });
    
    //default check status
    cartInsuranceTickStatus();

    $('.cartitems .cart-item .quantity-selector__button').click(function(){
     
      setTimeout(
  function() 
  {
    cartInsuranceDeleteAll();
    $('#transitInsurance').prop('checked', false);
  }, 2000);
      //cartInsuranceTickStatus();
      //console.log('xxx');
    });


      $('.cartitems .cart-item .quantity-selector__input').on('change',function(){
     
      setTimeout(
  function() 
  {
    cartInsuranceDeleteAll();
    $('#transitInsurance').prop('checked', false);
  }, 2000);
      //cartInsuranceTickStatus();
      //console.log('xxx');
    });
   
  }

 


   if($('.jw_cart_tooltip').length>0){
      $('.jw_cart_tooltip').tooltipster({
                contentAsHTML: true,
                maxWidth:400
                
            });
   }


  if($('#shopify-section-my-bundle').length >0){
    $('#shopify-section-my-bundle .jw_product_bundle_inner .jw_my_qickshop_btn > button').click(function(event){
        event.preventDefault();
        var my_prd_id = $(this).data('jw-my-prd-id');
        
        if(my_prd_id){
          //console.log('tttt'+my_prd_id);
          //$('#jw_cls_bundle_target_'+my_prd_id).trigger('click');
            
          $("#"+my_prd_id).trigger("click");
          //$("#jw_cls_bundle_target_4626564677713").trigger("click");
        }
    });

      if($('.jw_product_bundle_map_flashing').length > 0){
	   function jw_bundle_only_show_map_flashing(){
		 var my_select_index = $('.options-selection__select-wrapper select[data-variant-option-index="0"] option:selected').index();
		 $('#shopify-section-my-bundle.jw_product_bundle_map_flashing .jw_product_bundle_list li').hide();
		 $('#shopify-section-my-bundle.jw_product_bundle_map_flashing .jw_product_bundle_list li').eq(my_select_index).fadeIn();
	   }
	   jw_bundle_only_show_map_flashing();
	   
	   $('.options-selection__select-wrapper select[data-variant-option-index="0"]').change(function() {
			jw_bundle_only_show_map_flashing();
		});
	}
  }

  if($('.jw-prd-delivery-info').length > 0){
      /*var fromDate = new Date();
        fromDate.setDate(fromDate.getDate() + 6);
        if (fromDate.getDay() === 6 || fromDate.getDay() === 0) {
            fromDate.setDate(fromDate.getDate() + (8 - fromDate.getDay()));
        }
        var toDate = new Date();
        toDate.setDate(toDate.getDate() + 7);
        if (toDate.getDay() === 6 || toDate.getDay() === 0) {
            toDate.setDate(toDate.getDate() + (8 - toDate.getDay()));
        }
        $('#fromDate').text(fromDate.toLocaleDateString('en-US', { day: 'numeric', month: 'short' }));
        $('#toDate').text(toDate.toLocaleDateString('en-US', { day: 'numeric', month: 'short' }));*/

  }

  if($('#jw_prd_warranty').length > 0){
   
   // Add variant to the cart on checkbox click
    $('#jw_prd_warranty').on('click', function(event) {
      //event.preventDefault();
      var variantId = 40476811853905; // Replace with the actual variant ID
       var isChecked = $(this).prop('checked');
      if (isChecked) {
        var prd_title = $(this).data('prd-title'); 
        addWarrantToCart(variantId, prd_title);
      } else {
        removeWarrantFromCart(variantId);
      }

      //console.log('tttt');
       setTimeout(function() {
      jQuery.getJSON('/cart.js', function(cart) {
          console.log(cart.item_count);
          //$(".site-header-cart--count").prop('data-header-cart-count',cart.item_count);
        
       // Select the span element by its class
        var headerCartCount = $(".site-header-cart--count");

        // Update the data-header-cart-count value
        var newCount = cart.item_count; // Set your desired value here
        headerCartCount.attr("data-header-cart-count", newCount);
       });
     }, 2000);
    });
   
   // Shopify AJAX request to add variant to the cart 
    function addWarrantToCart(variantId,prd_title) {
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: {
          quantity: 1,
          id: variantId,
          properties : {
                "For Product" : prd_title
            }

        },
        success: function() {
          //alert('Variant added to the cart');
        },
        error: function() {
          //alert('Failed to add variant to the cart');
        }
      });
    }

    // Shopify AJAX request to remove variant from the cart
    function removeWarrantFromCart(variantId) {
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        dataType: 'json',
        data: {
          quantity: 0,
          id: variantId
        },
        success: function() {
          //alert('Variant removed from the cart');
        },
        error: function() {
          //alert('Failed to remove variant from the cart');
        }
      });
    }

   
   $('.jw_prd_warranty_tooltip').tooltipster({
                contentAsHTML: true,
                maxWidth:400
                
            });
 }

 if($('#jw_shipping_policy_box').length >0){
    // Attach a change event handler to the checkbox
    $('#jw_shipping_policy_box').on('change', function() {
      // Check if the checkbox is checked
      if ($(this).is(':checked')) {
        // If checked, enable the 'Check out' button
        $('.cart-checkout .button-primary,.cart-title-right .button-primary.cart-title-button').prop('disabled', false);
      } else {
        // If not checked, disable the 'Check out' button
        $('.cart-checkout .button-primary,.cart-title-right .button-primary.cart-title-button').prop('disabled', true);
      }
    });
    
    // Set the initial state of the 'Check out' button based on checkbox status
    if ($('#jw_shipping_policy_box').is(':checked')) {
      $('.cart-checkout .button-primary,.cart-title-right .button-primary.cart-title-button').prop('disabled', false);
    } else {
      $('.cart-checkout .button-primary,.cart-title-right .button-primary.cart-title-button').prop('disabled', true);
    }
 } 

  if($('#jw-flashing-all-sizes-wrapper').length > 0){
    // Attach change event listener to the select element
    $('#jw-flashing-all-sizes').change(function() {
      // Get the selected option value
      var selectedOption = $(this).val();
      
      // Redirect to the selected page
      window.location.href = selectedOption;
    });
  }


  // Check if there are any options in Dropdown B
  /*if ($('#jw_match_dsh_prd_list_main option').length > 0) {
    // When the 'Add to Cart' button is clicked
    $('#my_jw_prdocut_rule_add_to_cart_btn').on('click', function(event) {
      // Prevent default form behavior (if necessary, uncomment this line)
      // event.preventDefault(); 

      // Get the selected index of Dropdown A (using its class)
      var selectedIndexA = $('.options-selection__input-select').prop('selectedIndex');
      
      // Get the corresponding product ID from Dropdown B based on the selected index
      var selectedProductIdB = $('#jw_match_dsh_prd_list_main option').eq(selectedIndexA).val();
      
      // Log the selected index and corresponding product ID for testing
      console.log('Selected index in Dropdown A:', selectedIndexA);
      console.log('Corresponding Product ID from Dropdown B:', selectedProductIdB);
      
      // Delay the Add to Cart action by 2 seconds
      setTimeout(function() {
        // Add the corresponding product from Dropdown B to the cart
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: {
            id: selectedProductIdB,  // Product ID from Dropdown B
            quantity: 1              // Quantity of the item (set to 1)
          },
          dataType: 'json',
          success: function(response) {
            console.log('Product added to cart:', response);
            // Optionally update the cart UI here or display a success message
            //alert('Item added to cart');
          },
          error: function(error) {
            console.log('Error adding product to cart:', error);
            // Optionally display an error message
           // alert('There was an error adding the item to the cart.');
          }
        });
      }, 1000); // 2000 milliseconds (2 seconds delay)
    });
  }*/


   if ($('#jw_angle_wrapper').length > 0) {
    function checkJWAngleShowOrHide(){
      var roof_type = $('.options-selection__select-wrapper select[data-variant-option-index="0"] option:selected').val();
      if(roof_type.includes('0-15')){
          $('#jw_angle_wrapper').show();
          $('#jw_angle_wrapper #jw_angle_select').prop('disabled', false);
        $('.shopify-payment-button').hide();
      }else{
        $('#jw_angle_wrapper').hide();
          $('#jw_angle_wrapper #jw_angle_select').prop('disabled',true);
         $('.shopify-payment-button').show();
      }
    }
    checkJWAngleShowOrHide();
     $('.options-selection__select-wrapper select[data-variant-option-index="0"]').change(function() {
 		checkJWAngleShowOrHide();
	});
     
   }

  
});